<template>
  <div>
    <div class="col form-group">
      <input
        id="passport"
        v-model="obj.passport"
        class="w-100"
        :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
        placeholder="Passport"
        @input="validatePassport"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'passport',
  props: {
    validate: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    obj: {},
  }),
  computed: {
    ...mapState(['config', 'registrationObject', 'subdomain', 'template']),
    ownerId() {
      return this.config.ownerId
    },
  },
  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
  mounted() {
    // Create a deep copy of the object of the store
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))

    document.getElementById('passport').focus()
  },
  methods: {
    ...mapMutations([
      'updateRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
    ]),

    validateFields() {
      this.$emit('validating')
      this.clearRegistrationErrors()
      let hasErrors = false

      if (!this.obj.passport) {
        this.addRegistrationError({
          msg: 'It is necessary to inform the Passport number.',
        })

        hasErrors = true
      }

      if (!hasErrors) {
        this.$store.commit('updateRegistrationObject', this.obj)

        this.$emit('next')
      }
    },
    validatePassport(event) {
      let value = event.target.value

      this.obj.passport = value.replace(/[@.]/g, '')

      if (value !== this.obj.passport) {
        this.addRegistrationError({
          msg: 'Invalid characters ( . or @ ) are not allowed.',
        })
        hasErrors = true
      }
    },
  },
}
</script>
